import React, { useContext } from "react"
import { Card, CardBody, Col } from "reactstrap"


function Header({onCreate}) {

  const reload =() => {
    fetchAllApptSys()
  }

  return (
    <Card>
      <CardBody>
        <Col>
          <div className="float-start">
            <h5 className="text-primary">Location Map Import</h5>
          </div>
        </Col>
      </CardBody>
    </Card>
  )
}

export default Header
